import React from 'react';

import './style.css';

class InputEditable extends React.Component {
  state = {
    text: this.props.text
  }
  handlerText = (e) => this.setState({ text: e.target.value })
  handlreClick = (button, id) =>{
    if(button === 'accept') this.props.onAccept(id, this.state.text)
    else this.props.onCancel(id)
    this.setState({text:''})
  }

  render() {
    return (
      <div className='edit-text-input-container'>
        <input type='text' value={this.state.text} onChange={this.handlerText} className={this.props.small ? 'edit-small edit-text-input':'edit-text-input'}></input>
        <i className='fas fa-check edit-text-input-buttons' style={{color:'green'}} onClick={() => this.handlreClick('accept', this.props.id)}></i>
        <i className='fas fa-times edit-text-input-buttons' style={{color:'red'}} onClick={() => this.handlreClick('cancel', this.props.id)}></i>
      </div>
    )
  }
}

export default InputEditable;